"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

var _Modal = _interopRequireDefault(require("elevate-ui/Modal"));

var _find = _interopRequireDefault(require("lodash/find"));

var _Add = _interopRequireDefault(require("elevate-ui-icons/Add"));

var _ComponentList = _interopRequireDefault(require("./ComponentList"));

var _ComponentPreview = _interopRequireDefault(require("./ComponentPreview"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ToolboxModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(ToolboxModal, _Component);

  var _super = _createSuper(ToolboxModal);

  function ToolboxModal(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ToolboxModal);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "filterComponents", function (e) {
      var components = _this.state.components;
      var input = e.target.value;
      var filtered = components.filter(function (component) {
        if (component.type && component.type.toLowerCase().includes(input.toLowerCase()) || component.label && component.label.toLowerCase().includes(input.toLowerCase())) {
          return true;
        }

        return false;
      });

      _this.setState({
        filteredComponents: filtered,
        filterInput: input
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleComponentClick", function (type) {
      var component = (0, _find["default"])(_this.state.components, function (component) {
        return component.type === type;
      });

      _this.setState({
        activeComponent: component
      });
    });
    _this.state = {
      activeComponent: null,
      components: props.components,
      filteredComponents: props.components,
      filterInput: "",
      parentId: props.id || null
    };
    return _this;
  }

  (0, _createClass2["default"])(ToolboxModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.id !== this.props.id) {
        this.setState({
          parentId: this.props.id
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          onCancel = _this$props.onCancel,
          onSelect = _this$props.onSelect,
          internals = _this$props.internals;
      var _this$state = this.state,
          activeComponent = _this$state.activeComponent,
          filteredComponents = _this$state.filteredComponents,
          filterInput = _this$state.filterInput,
          parentId = _this$state.parentId;

      if (!parentId) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
        classes: {
          root: classes.root,
          body: classes.body
        },
        cancelText: "Cancel",
        confirmAction: function confirmAction() {
          return onSelect(parentId, activeComponent && activeComponent.type);
        },
        confirmIcon: /*#__PURE__*/_react["default"].createElement(_Add["default"], null),
        confirmText: "Add Component",
        toggleModal: onCancel,
        title: "Select a component",
        visible: true
      }, /*#__PURE__*/_react["default"].createElement(_ComponentList["default"], {
        activeComponent: activeComponent,
        components: filteredComponents,
        filterComponents: this.filterComponents,
        filterInput: filterInput,
        handleComponentClick: this.handleComponentClick
      }), /*#__PURE__*/_react["default"].createElement(_ComponentPreview["default"], {
        key: activeComponent && activeComponent.type,
        internals: internals,
        activeComponent: activeComponent
      }));
    }
  }]);
  return ToolboxModal;
}(_react.Component);

var styles = function styles(theme) {
  return {
    root: (0, _defineProperty2["default"])({
      display: "flex",
      position: "relative",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "center",
      margin: "0 auto",
      maxHeight: "90vh",
      overflowY: "scroll",
      border: "none",
      boxShadow: "0px 1px 5px 0px rgba(0, 0, 0, 0.2),0px 2px 2px 0px rgba(0, 0, 0, 0.14),0px 3px 1px -2px rgba(0, 0, 0, 0.12)",
      overflow: "hidden",
      "@media (min-width: 450px)": {
        minWidth: "450px"
      }
    }, theme.breakpoints(900), {
      maxHeight: "70vh",
      maxWidth: "760px"
    }),
    body: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      overflowY: "scroll",
      width: "100%"
    }
  };
};

var _default = (0, _withStyles["default"])(styles, {
  name: "ToolboxModal"
})(ToolboxModal);

exports["default"] = _default;